module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/special_sticker-4be1a385eb4bc44fedeabf2af49f7288.png";